import postal from 'postal';

/**
 * Application Channel
 *
 * A channel where application wide events can be published.
 * Any Component can listen to this channel to respond to such events.
 *
 * example cases:
 * "user.login.success"
 * "user.login.failure"
 *
 * "modal.thankyou.opened"
 * "modal.thankyou.closed"
 *
 * "checkout.completed"
 * "checkout.cancelled"
 *
 */
export const appChannel = postal.channel('app');

/**
 * Exceptions Channel
 *
 * Components can publish exceptions here which will get logged to datadog by the ExceptionsService.
 * Components can listen to exceptions from this channel to react to failures of other components.
 */
// TODO: create ExceptionService to handle events from this channel
export const exceptionsChannel = postal.channel('exceptions');

// -------------------------

// ### example of how to subscribe to a channel
// var subscription = appChannel.subscribe('item.add', (data, envelope) => { });

// ### example of how to publish an event to the channel with a payload
// appChannel.publish('item.add', {
//   sku: 'AZDTF4346',
//   qty: 21,
// });

export const eventThankYouSent = 'thankyou.sent';
